
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  display:block;
  padding-top:var(
    --outline-container-padding-y,
    var(--outline-container--default-padding-y)
  );
  padding-bottom:var(
    --outline-container-padding-y,
    var(--outline-container--default-padding-y)
  );
  padding-left:var(
    --outline-container-padding-x,
    var(--outline-container--default-padding-x)
  );
  padding-right:var(
    --outline-container-padding-x,
    var(--outline-container--default-padding-x)
  );
}

:host([site='GHS']){
  font-family:var(--font-body)
}

@media (min-width: 640px) {

  :host([site='GHS']) {
    max-width:640px;
  }
}

@media (min-width: 768px) {

  :host([site='GHS']) {
    max-width:768px;
  }
}

@media (min-width: 1024px) {

  :host([site='GHS']) {
    max-width:1024px;
  }
}

@media (min-width: 1280px) {

  :host([site='GHS']) {
    max-width:1280px;
  }
}

@media (min-width: 1360px) {

  :host([site='GHS']) {
    max-width:1360px;
  }
}

@media (min-width: 2180px) {

  :host([site='GHS']) {
    max-width:1360px;
  }
}

@media (min-width: 1280px) {

  :host([site='GHS']):host([narrow-width]) {
    max-width:1024px;
  }
}

@media (min-width: 1360px) {

  :host([site='GHS']):host([narrow-width]) {
    max-width:1024px;
  }
}

@media (min-width: 2180px) {

  :host([site='GHS']):host([narrow-width]) {
    max-width:1024px;
  }
}

:host([site='GHS']):host([full-bleed]){
    max-width:100%;
  }

:host([site='BH']){
  font-family:var(--bh-ff-body)
}

@media (min-width: 640px) {

  :host([site='BH']) {
    max-width:640px;
  }
}

@media (min-width: 768px) {

  :host([site='BH']) {
    max-width:768px;
  }
}

@media (min-width: 1024px) {

  :host([site='BH']) {
    max-width:1024px;
  }
}

@media (min-width: 1280px) {

  :host([site='BH']) {
    max-width:1280px;
  }
}

@media (min-width: 1360px) {

  :host([site='BH']) {
    max-width:1360px;
  }
}

@media (min-width: 2180px) {

  :host([site='BH']) {
    max-width:2000px;
  }
}

@media (min-width: 2180px) {

  :host([site='BH']):host([x-padding]) {
    padding-left:0px;
    padding-right:0px;
  }
}

@media (min-width: 640px) {

  :host([site='BH']):host([x-narrow-width]) {
    max-width:626px;
  }
}

@media (min-width: 768px) {

  :host([site='BH']):host([x-narrow-width]) {
    max-width:626px;
  }
}

@media (min-width: 1024px) {

  :host([site='BH']):host([x-narrow-width]) {
    max-width:626px;
  }
}

@media (min-width: 1280px) {

  :host([site='BH']):host([x-narrow-width]) {
    max-width:626px;
  }
}

@media (min-width: 1360px) {

  :host([site='BH']):host([x-narrow-width]) {
    max-width:626px;
  }
}

@media (min-width: 2180px) {

  :host([site='BH']):host([x-narrow-width]) {
    max-width:626px;
  }
}

@media (min-width: 1280px) {

  :host([site='BH']):host([narrow-width]) {
    max-width:1132px;
  }
}

@media (min-width: 1360px) {

  :host([site='BH']):host([narrow-width]) {
    max-width:1132px;
  }
}

@media (min-width: 2180px) {

  :host([site='BH']):host([narrow-width]) {
    max-width:1132px;
  }
}

@media (min-width: 1280px) {

  :host([site='BH']):host([medium-width]) {
    max-width:1206px;
  }
}

@media (min-width: 1360px) {

  :host([site='BH']):host([medium-width]) {
    max-width:1246px;
  }
}

@media (min-width: 2180px) {

  :host([site='BH']):host([medium-width]) {
    max-width:1388px;
  }
}

:host([site='BH']):host([full-bleed]) {
  max-width:2000px;
}

:host([site='BH']):host([full-bleed-extend]) {
  max-width:100%;
}

:host([container-align]),
:host([container-align='center']){
  margin-left:auto;
  margin-right:auto;
}

:host([container-align='left']){
  margin-left:0;
  margin-right:auto;
}

:host([container-align='right']){
  margin-left:auto;
  margin-right:0;
}

:host(:not([x-padding])){
  padding-left:0;
  padding-right:0;
}

:host(:not([y-padding])){
  padding-top:0;
  padding-bottom:0;
}
`;